import newraiANTDPackageEN from "@neonumy/ant-design/lib/resources/i18n/locales/en/newraiANTDPackage.json";
import newraiANTDPackageFR from "@neonumy/ant-design/lib/resources/i18n/locales/fr/newraiANTDPackage.json";
import docPreviewPackageEN from "@neonumy/documents-preview/lib/resources/locales/en/docPreviewPackage.json";
import docPreviewPackageFR from "@neonumy/documents-preview/lib/resources/locales/fr/docPreviewPackage.json";
import neonumyUiTranslationsEn from "@neonumy/neonumy-ui/lib/resources/locales/en/neonumy-ui.json";
import neonumyUiTranslationsFr from "@neonumy/neonumy-ui/lib/resources/locales/fr/neonumy-ui.json";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "resources/locales/en/translation.json";
import translationFR from "resources/locales/fr/translation.json";

const resources = {
  en: {
    translation: translationEN,
    newraiANTDPackage: newraiANTDPackageEN,
    docPreviewPackage: docPreviewPackageEN,
    "neonumy-ui": neonumyUiTranslationsEn,
  },
  fr: {
    translation: translationFR,
    newraiANTDPackage: newraiANTDPackageFR,
    docPreviewPackage: docPreviewPackageFR,
    "neonumy-ui": neonumyUiTranslationsFr,
  },
};

export const langsCode = ["fr", "en"];

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("i18nextLng") || langsCode[0],
  fallbackLng: langsCode,
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
  ns: ["translation", "newraiANTDPackage", "neonumy-ui", "docPreviewPackage"],
  defaultNS: "translation",
});

export const langsLabel = () => [i18n.t("French"), i18n.t("English")];
export default i18n;
